import { Toast } from './../../../../services'

export default {
  name: 'greenCertificatesTradeItem',
  props: {
    project: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    goToDetails() {
      this.$router.push('/tradeofco2/details/' + this.project._id)
    },
    buyNow() {
      Toast.notImplemented({
        toast: this.$toast,
      })
    },
  },
  async created() {
    $('.panel-content').tooltip({
        selector: "[data-toggle=tooltip]",
        container: "body"
    })
  },
}



// WEBPACK FOOTER //
// ./src/components/TradeOfCO2/TradeBoard/GreenCertificatesTradeItem/GreenCertificatesTradeItem.component.js